import {writable} from 'svelte/store';


const {set, update, subscribe} = writable({
    id: 0,
    name: null,
    is_admin: false,
    credits: 0,
    session: null,
});

const user = {
    set,
    update,
    subscribe,
    updateAccount: account => {
        user.update(u => {
            u.name = account.name;
            u.lastname = account.lastname;
            u.phone = account.phone;
            u.mobile = account.mobile;
            u.email = account.email;
            u.originator = account.originator;
            u.username = account.username;
            return u;
        })
    },
    updateCredits: credits => {
        user.update(u => {
            u.credits = credits;
            return u;
        })
    },
    addCredits: credits_to_add => {
        user.update(u => {
            u.credits+= credits_to_add;
            return u;
        })
    },
    removeCredits: credits_to_remove => {
        user.update(u => {
            u.credits-= credits_to_remove;
            return u;
        })
    },
}

export default user;